import React, {FC} from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import useLocalization from '../../../../../hooks/useLocalization';
import useStyles from './ActivationPanel.styles';

import ActivationsList, {ActivationsListProps} from './activations-data/ActivationsList';
import ActivationsListSkeleton from './activations-data/ActivationsListSkeleton';
import ActivationsPanelNoData from './activations-data/ActivationsPanelNoData';

const CODES = {
    triggerColumnName: 'epic.affiliate.fortnite_games.xp.activations_list.accolade_column_name',
    activationsColumnName:
        'epic.affiliate.fortnite_games.xp.activations_list.activations_column_name'
};

interface TriggeredActivationsProps extends ActivationsListProps {
    isLoading: boolean;
}

const ActivationsPanel: FC<TriggeredActivationsProps> = ({
    isLoading,
    ...props
}: TriggeredActivationsProps) => {
    const styles = useStyles();
    const getMessage = useLocalization();
    const hasActivationData = props.activations && props.activations.length;

    if (!isLoading && !hasActivationData) {
        return <ActivationsPanelNoData />;
    }

    return (
        <Box className={styles.activationsWrapper}>
            <Box className={styles.headersWrapper}>
                <Typography className={styles.headerName}>
                    {getMessage(CODES.triggerColumnName)}
                </Typography>
                <Typography className={styles.headerActivationNumber}>
                    {getMessage(CODES.activationsColumnName)}
                </Typography>
            </Box>
            {isLoading ? <ActivationsListSkeleton /> : <ActivationsList {...props} />}
        </Box>
    );
};

export default ActivationsPanel;
